const API_ENDPOINTS = {
    LOGIN: '/users/login/',
    REGISTER: '/users/register/',
    CHECK_USERNAME: '/users/unique/',
    SYNC: '/sync/v1/sync/',
    CHECK_PHONE_NUMBER: '/users/uniquephone/',
    UPLOAD_IMAGE: '/sync/v1/upload/',
    UPDATE_PASSWORD: 'users/update_password/',
    GET_CATALOGS: 'products/uploadCatalog',
    CREATE_DEVICE: '/kds/createDevice/',
    UPDATE_PIN: '/kds/updatePin/',
    UPDATE_ODOO_CONFIG: '/kds/updateOdooConfig/',
    LOGIN_DEVICE: 'kds/loginDevice/',
    VALIDATE_PIN: 'kds/loginDevicePin/',
    GET_KDS_ORDER: '/kds/order/',
    UPDATE_KDS_ORDER: '/kds/orderUpdateDelete/',
    WEB_SOCKET_URL: 'ws://172.16.16.116:8000/ws/kitchen/',
    KITCHEN_NOTIFICATIONS: '/kds/kitchenNotifications/',
    UPDATE_DEVICE_CONFIG: '/kds/deviceConfigUpdate/',
    SEND_EMAIL: '/kds/emailSecretKey/',
    SEND_USER_CRED: '/users/sendEmail/',
    GET_COUNTRY: '/marketplace/all/countryProvinceCities/',
};

export default API_ENDPOINTS;
